<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="titleMap[type] || ''"
      visible
      direction="rtl"
      :size="1000"
      :before-close="() => $refs.main.cancel()"
      @close="close"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :expoSampleCode="expoSampleCode"
          @close="close"
          @reload="$emit('reload')"
        />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ this.$l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
        <el-button
          v-if="type == 'audit'"
          type="success"
          size="small"
          @click="audit()"
        >
          {{ $l('INDEX.btn_audit') || '审核' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    meetTitle: { type: Boolean, default: true },
    type: { type: String, default: '' },
    expoSampleCode: { type: String, default: '' },
  },
  computed: {
    disabled() {
      return ['detail', 'audit'].includes(this.type)
    },
    titleMap() {
      return {
        edit:
          (this.meetTitle
            ? this.$l('dialog_title_edit')
            : this.$l('dialog_title_sampleEdit')) || '编辑展品信息',
        detail: this.$l('dialog_title_detail') || '查看展品信息',
        audit: this.$l('dialog_title_audit') || '审核展品信息',
        change: this.$l('dialog_title_change') || '变更展品信息',
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async audit() {
      const confirm = await this.$confirm(
        this.$l('confirm_auditExpoSample') || '是否要审核该展品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      this.loadingOpen()
      const res = await this.$api
        .expoSampleAuditApi({ expoSampleCode: this.expoSampleCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_audit_failure') || '审核失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_audit_success') || '审核成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 32px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
